import { DialogActions as MUIDialogActions } from '@mui/material';

interface DialogActionProps {
  children?: React.ReactNode;
}

/**
 * 공용 Dialog Action 영역 레이아웃
 *
 * @package
 */
export default function DialogActions({ children }: DialogActionProps) {
  return (
    <MUIDialogActions
      sx={theme => ({
        px: 4,
        pb: 3,
        pt: 0,
      })}
    >
      {children}
    </MUIDialogActions>
  );
}
